export const AUTH_KEY = '_auth'